var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrangeRegularIsometric(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 521.16 391.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#207d8c;}.cls-2{fill:#a85d26;}.cls-3{fill:#f47421;}.cls-4{fill:#3a2715;}.cls-5{fill:#2d1e13;}.cls-6{fill:#8e5523;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M519.39,231.18C517.13,228.83,318.89,22.73,311,14.4c-8.55-8.95-19.88-4.84-20.09-4.76.1,0,.66-.27-9.53,2.65-10.79,3.08-14.29-.8-14.29-.8s-4-5.24-17.63-1.28C233.58,14.78,7.86,72.14,7.86,72.14S.77,74,.69,81.23,0,126,0,126,195.25,377.36,202.91,387.32c6.27,8.2,22,2.49,22,2.49S509,286.84,515.64,284.4c5.81-2.49,5.39-7.66,5.39-7.66l.13-37.91S521.36,233.29,519.39,231.18Zm-96-58.92-184,60.7a10.85,10.85,0,0,1-11-3.26l-91-113.52c-2.41-3-1.34-6.31,2.36-7.35L316.8,59.24a12.75,12.75,0,0,1,11.54,3.2L425.21,165C427.86,167.78,427,171.06,423.37,172.26Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M484.71,185.58C482.82,183.62,317.63,11.86,311,4.93c-7.11-7.46-16.56-4-16.73-4,.08,0,.55-.23-7.94,2.2-9,2.58-11.92-.66-11.92-.66s-3.29-4.36-14.69-1.07C246.53,5.24,58.43,53,58.43,53s-5.91,1.52-6,7.57-.58,37.3-.58,37.3S214.59,307.39,221,315.69c5.22,6.83,18.35,2.08,18.35,2.08S476.07,232,481.58,229.92c4.84-2.07,4.5-6.38,4.5-6.38l.1-31.59S486.35,187.34,484.71,185.58Zm-61.34-13.32-184,60.7a10.85,10.85,0,0,1-11-3.26l-91-113.52c-2.41-3-1.34-6.31,2.36-7.35L316.8,59.24a12.75,12.75,0,0,1,11.54,3.2L425.21,165C427.86,167.78,427,171.06,423.37,172.26Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M482.09,182.73S317.63,11.75,311,4.81c-7.11-7.46-16.56-4-16.73-4,.08,0,.55-.22-7.94,2.21-9,2.57-11.92-.66-11.92-.66S271.12-2,259.72,1.31C246.53,5.12,58.43,52.93,58.43,52.93s-8.71,3-3.6,9.42L103.43,126S210.94,261.24,219,271.29s23.12,3.88,23.12,3.88,227.06-77.39,237.78-81S482.09,182.73,482.09,182.73Zm-58.72-10.47-184,60.7a10.85,10.85,0,0,1-11-3.26l-91-113.52c-2.41-3-1.34-6.31,2.36-7.35L316.8,59.24a12.75,12.75,0,0,1,11.54,3.2L425.21,165C427.86,167.78,427,171.06,423.37,172.26Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "243.79 281.15 243.79 308.67 476.61 224.48 476.61 201.17 243.79 281.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "476.61 201.17 460.26 206.84 476.61 224.48 476.61 201.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M114.13,128.13l-7.76,1.57C123.64,151.42,211.73,262.23,219,271.29A15.61,15.61,0,0,0,230.73,277Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M482.09,182.73S411.56,109.41,361,56.84l-4.08,1.74L484.35,191.4C487.38,187.58,482.09,182.73,482.09,182.73Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M118.67,58.53C110.2,60.72,92,67.2,102,80.09S127,93.35,144.45,88.52s132.73-36.46,143.9-39.6,25.7-9.77,12.89-21.8-30.41-8.71-44.76-4.92S127.15,56.33,118.67,58.53Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M319.08,13.22l-2-2L292,17.92a31.13,31.13,0,0,1,3.67,1.6Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M94.46,70.72,66.77,78.07l1.92,2.51,25.8-6.91A9.15,9.15,0,0,1,94.46,70.72Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M323.29,17.6l-2-2-22.27,6a29,29,0,0,1,2.45,1.92Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M70.28,82.62l1.93,2.5,24.23-6.47A17.48,17.48,0,0,1,95.15,76Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M305.62,27.77l21.75-5.92-1.94-2-21.6,5.86c.32.33.64.67.94,1S305.35,27.42,305.62,27.77Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M98.26,81.29,74.2,87.8l1.94,2.49,24.13-6.59c-.47-.53-1-1.08-1.42-1.65C98.64,81.79,98.46,81.54,98.26,81.29Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M77.91,92.56l2,2.49L105,88.16c-.88-.69-1.74-1.44-2.59-2.25Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M331.46,26.1l-1.94-2-22.23,6.05a16.87,16.87,0,0,1,1.17,2.26Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M81.11,96.8l2,2.48,27.69-7.54a30.71,30.71,0,0,1-3.51-2Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M309.26,37.37l26.16-7.16-1.93-2-24.31,6.61A8.81,8.81,0,0,1,309.26,37.37Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M431.32,165.28,331.71,59.9a16.44,16.44,0,0,0-14.84-4.11l-183.54,51.5c-4.77,1.34-6.13,5.59-3,9.44l94.33,117.15a14,14,0,0,0,14.18,4.17L429,174.66C433.66,173.1,434.72,168.87,431.32,165.28Zm-7.95,7-184,60.7a10.85,10.85,0,0,1-11-3.26l-91-113.52c-2.41-3-1.34-6.31,2.36-7.35L316.8,59.24a12.75,12.75,0,0,1,11.54,3.2L425.21,165C427.86,167.78,427,171.06,423.37,172.26Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M332.14,217.59c-3.12-1.08-3.11-2.79,0-3.82l22.32-7.3c3.13-1,5.27.8,4.74,4.06l-1.55,9.58a4.9,4.9,0,0,1-6.63,4Z",
    transform: "translate(0 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeRegularIsometric);
export default __webpack_public_path__ + "static/media/orange-regular-isometric.2d50d2cc3129d93f1f4cd22b8e573aa8.svg";
export { ForwardRef as ReactComponent };